import React from 'react';
import { createPortal } from 'react-dom';

const FILE_URL = 'https://www.carlogos.org/car-logos/';

export function getCarLogo(make) {
    return `${FILE_URL}${make === 'default' ? 'porsche' : make}-logo.png`;
}

export function validatePhoneNumber(input) {    
    const digitsOnly = input.replace(/\D/g, '');
    
    if (digitsOnly.length <= 10) {
        return digitsOnly;
    } else {
        return digitsOnly.slice(0, 10);
    }
}

export function generateDealPayload (state) {

    let requestPayload = {
        vehicleinfo: {
            rego: state.rego
            ,registrationstate: state.regoLocState
            ,carlocationpostcode: state.carLocPostcode
        }
        , vehiclecondition: {
            odometer: state.odometer
            ,tyres : state.tyres
            ,interior_condition: this.state.interior_condition.toLowerCase().replaceAll(' ','_')
            ,exterior_condition: this.state.exterior_condition.toLowerCase().replaceAll(' ','_')
            ,keys: this.state.keys 
            ,books: this.state.books.toLowerCase().replaceAll(' ','_')
            ,service_history: this.state.service_history.toLowerCase().replaceAll(' ','_')
            ,comments: this.state.comments
            ,is_imported: false 
            ,car_damage: false
            ,delivery_period: this.state.estimated_arrival.toLowerCase().replaceAll(' ','_').replaceAll('-','_')
        }
        , listingsettings: {
            sale_type: "customer_direct_listing"
            ,listing_duration: 24
        }        
    };
    return requestPayload;
}

export function stateSerialiser(state) {
    return {
        vehicleinfo: {
            rego: state.rego,
            registrationstate: state.regoLocState,
            carlocationpostcode: state.carLocPostcode
        },
        vehiclecondition: {
            odometer: state.odometer,
            tyres: state.tyres > 0 ? `Replace ${state.tyres}` : 'No replacement',
            interior_condition: state.interior_condition.toLowerCase().replaceAll(' ', '_'),
            exterior_condition: state.exterior_condition.toLowerCase().replaceAll(' ', '_'),
            keys: state.keys,
            books: state.books.toLowerCase().replaceAll(' ', '_'),
            service_history: state.service_history.toLowerCase().replaceAll(' ', '_'),
            comments: state.comments,
            is_imported: false,
            car_damage: false,
            delivery_period: "Immediate"
        },
        listingsettings: {
            sale_type: "valuation",
            listing_duration: 24
        }
    };
}

// 🔧 Utility function to build the pages array based on feature flags
export function buildPagesFlow(flags) {
  const pages = ['Contact', 'Car Info', 'Overview'];

  // Only include "Details" page if not explicitly hidden
  if (!flags.hideDetails) pages.push('Details');

  // Only include "Valuation" page if not explicitly hidden
  if (!flags.hideValuation) pages.push('Valuation');

  // Only include "Done!" page if not explicitly hidden
  if (!flags.hideDone) pages.push('Done!');
  
  return pages;
};
  
export function isValidEmail(email) {
  
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

};

export function Logo({ src, align = 'top-left', size = '50px' }) {
  const isMobile = window.innerWidth <= 768;
  
  const getAlignment = () => {
    const mobileTopOffset = isMobile ? 'max(env(safe-area-inset-top, 10px), 10px)' : '20px';
    const mobileRightOffset = isMobile ? 'max(env(safe-area-inset-right, 20px), 20px)' : '20px';
    const mobileLeftOffset = isMobile ? 'max(env(safe-area-inset-left, 20px), 20px)' : '20px';
    
    switch (align) {
      case 'center':
        return {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10000,
        };
      case 'top-center':
        return {
          position: 'fixed',
          top: mobileTopOffset,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10000,
        };
      case 'top-right':
        return {
          position: 'fixed',
          top: mobileTopOffset,
          right: mobileRightOffset,
          zIndex: 10000,
        };
      case 'top-left':
      default:
        return {
          position: 'fixed',
          top: mobileTopOffset,
          left: mobileLeftOffset,
          zIndex: 10000,
        };
    }
  };

  return createPortal(
    <img
      src={src}
      alt="logo"
      style={{
        ...getAlignment(),
        height: size,
        maxWidth: 'calc(100vw - 40px)',
        objectFit: 'contain',
        isolation: 'isolate',
      }}
    />,
    document.body
  );
}